import Vue from "vue";
import VueRouter from "vue-router";
let Main = () => import("../views/Main.vue");
let Home = () => import("../views/Home.vue");
let Login = () => import("../views/Login.vue");
let About = () => import("../views/About.vue");
let Feedback = () => import("../views/Feedback.vue");
let Search = () => import("../views/Search.vue");
let Upload = () => import("../views/Upload.vue");
let Details = () => import("../views/Details.vue");
let userCen = () => import("../views/userCen.vue");
import { getToken, map } from "../utils/util.js";
Vue.use(VueRouter);

const routes = [
  { path: "/", name: "Home", component: Home },
  { path: "/search", name: "Main", component: Main },
  { path: "/login", name: "login", component: Login },
  { path: "/about", name: "About", component: About },
  { path: "/feedback", name: "Feedback", component: Feedback },
  { path: "/search", name: "Search", component: Search },
  { path: "/upload", name: "Upload", component: Upload },
  { path: "/details", name: "Details", component: Details },
  { path: "/userCen", name: "userCen", component: userCen },
];

const router = new VueRouter({
  // mode: "history",
  // base: "/qdC/hjc/physics/",
  routes,
});
router.beforeEach((to, from, next) => {
  console.log(`Navigating from ${from.path} to ${to.path}`);

  // 检查目标页面的路由
  if (to.path === "/details") {
    // 检查是否有查询参数
    const { id } = to.query;
    if (!id) {
      // 如果没有参数，重定向到首页
      next({ path: "/" });
    } else {
      // 否则，继续导航
      next();
    }
  } else {
    // 对于其他页面，继续导航
    next();
  }
});
// router.beforeEach((to, from, next) => {
//   if (to.path === "/") {
//     return next();
//   }
//   getToken() ? next() : next("/");
// });

router.afterEach((to, from, next) => {
  // document.title = map.get(to.path);
  document.title = map.get(to.path) || "Electron Micrograph Project";
});

// 防止连续点击多次路由报错
let routerPush = VueRouter.prototype.push;
let routerReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((err) => err);
};
// replace
VueRouter.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch((err) => err);
};

export default router;
